import React from 'react';
import { ManagerNavbar } from '../../Components/Navbars';

import { Candidates } from './Candidates';
import { UserRole } from '../../Enums/UserRole';

export const CandidatesForManager = () => {
    return (
        <>
            <ManagerNavbar />
            <Candidates role={UserRole.Manager}/>
        </>
    );
};